import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Construction } from "lucide-react";
import { Button } from "../components/ui/button";

export default function Maintenance({ featureName, isGlobal }) {
  const navigate = useNavigate();

  if (isGlobal) {
    return (
      <div className="flex min-h-screen w-full flex-col items-center justify-center bg-hospital-bg p-6 text-center animate-fade-in">
        <div className="relative mb-6">
          <div className="absolute inset-0 rounded-full bg-hospital-primary/10 blur-xl animate-pulse"></div>
          <div className="relative flex h-24 w-24 items-center justify-center rounded-3xl bg-hospital-primary-light border border-hospital-accent text-hospital-primary">
            <Construction className="h-12 w-12 animate-bounce" style={{ animationDuration: "3s" }} />
          </div>
        </div>
        
        <h2 className="font-manrope text-3xl font-extrabold text-hospital-text-main mb-3 tracking-tight">
          System Optimization in Progress
        </h2>
        
        <p className="max-w-md text-base text-hospital-text-secondary mb-8 leading-relaxed">
          We are currently performing major optimizations on <strong className="text-hospital-primary">ParshCare</strong> to enhance performance, speed, and security. 
          The website will be back online shortly. Thank you for your patience!
        </p>

        <div className="text-xs font-semibold uppercase tracking-wider text-hospital-text-muted bg-white px-4 py-2 rounded-full border border-gray-150 shadow-sm animate-pulse">
          Optimization Mode Active
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center p-6 text-center animate-fade-in">
      <div className="relative mb-6">
        <div className="absolute inset-0 rounded-full bg-hospital-primary/10 blur-xl animate-pulse"></div>
        <div className="relative flex h-20 w-20 items-center justify-center rounded-2xl bg-hospital-primary-light border border-hospital-accent text-hospital-primary">
          <Construction className="h-10 w-10 animate-bounce" style={{ animationDuration: "3s" }} />
        </div>
      </div>
      
      <h2 className="font-manrope text-2xl font-bold text-hospital-text-main mb-2">
        {featureName || "Feature"} Under Maintenance
      </h2>
      
      <p className="max-w-md text-sm text-hospital-text-secondary mb-8 leading-relaxed">
        We are currently upgrading the <strong className="text-hospital-primary">{featureName || "requested module"}</strong> feature to bring you a more seamless and powerful experience. 
        It will be back online shortly. Thank you for your cooperation!
      </p>

      <div className="flex flex-col sm:flex-row gap-4">
        <Button 
          variant="outline"
          className="border-gray-200 text-hospital-text-main hover:bg-gray-50 flex items-center gap-2"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft className="h-4 w-4" />
          Go Back
        </Button>
        <Button 
          className="bg-hospital-primary hover:bg-hospital-primary-hover text-white flex items-center gap-2"
          onClick={() => navigate("/")}
        >
          Dashboard
        </Button>
      </div>
    </div>
  );
}
